/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_Form_Enum_Willingness_To_Learn_Curiosity27Inputs */

const en_job_form_enum_willingness_to_learn_curiosity27 = /** @type {(inputs: Job_Form_Enum_Willingness_To_Learn_Curiosity27Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Willingness to Learn and Curiosity`)
};

const de_job_form_enum_willingness_to_learn_curiosity27 = /** @type {(inputs: Job_Form_Enum_Willingness_To_Learn_Curiosity27Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lernbereitschaft und Neugier`)
};

/**
* | output |
* | --- |
* | "Willingness to Learn and Curiosity" |
*
* @param {Job_Form_Enum_Willingness_To_Learn_Curiosity27Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const job_form_enum_willingness_to_learn_curiosity27 = /** @type {((inputs?: Job_Form_Enum_Willingness_To_Learn_Curiosity27Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_Form_Enum_Willingness_To_Learn_Curiosity27Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_job_form_enum_willingness_to_learn_curiosity27(inputs)
	return en_job_form_enum_willingness_to_learn_curiosity27(inputs)
});
export { job_form_enum_willingness_to_learn_curiosity27 as "job_form_enum_WILLINGNESS_TO_LEARN_CURIOSITY" }